import { render, staticRenderFns } from "./ManagerAdminActions.vue?vue&type=template&id=0e2f8864&scoped=true&"
import script from "./ManagerAdminActions.vue?vue&type=script&lang=js&"
export * from "./ManagerAdminActions.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/manager-admin-actions.scss?vue&type=style&index=0&id=0e2f8864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2f8864",
  null
  
)

export default component.exports